import { Context } from "@nuxt/types";

import Api from "@/utils/api";

export default class SignedPolicies extends Api {
  readonly url = `/v2/signed_policies${process.client ? "/" : ""}`;

  constructor($axios: Context["$axios"]) {
    super("consumerProfileService", $axios);
  }

  async get() {
    return await this.request<SignedPoliciesResponse>({
      method: "GET",
    });
  }

  async patch(data: SignedPoliciesPatchData) {
    return await this.request<SignedPoliciesResponse>({
      method: "PATCH",
      data,
    });
  }
}
